import axios from "axios";
import Notiflix from "notiflix";
import { getVersionHeader } from "../shared/constants/version";

// Determine the base URL dynamically based on the hostname
const hostname = window.location.hostname;

// Map hostname to the corresponding base URL
// nginx serves both the bare and www hostnames, so both need an entry here.
// An unmapped hostname falls through to the default at BASE_URL below.
const BASE_URL_MAP = {
  "celltop.vip": "https://api.celltop.vip/api/v1/resources/",
  "www.celltop.vip": "https://api.celltop.vip/api/v1/resources/",
  "localhost": "http://localhost:5000/api/v1/resources/",
  "127.0.0.1": "http://127.0.0.1:5000/api/v1/resources/",
};

// Check if running locally (localhost or 127.0.0.1)
const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1" || hostname === "";

// Default to localhost for local development, otherwise use production
export const BASE_URL = BASE_URL_MAP[hostname] || (isLocalhost ? "http://localhost:5000/api/v1/resources/" : BASE_URL_MAP["celltop.vip"]);

// Log API URL for debugging
console.log(`[API Config] Hostname: ${hostname}, API Base URL: ${BASE_URL}`);

// Retrieve the IP from localStorage
export const IP = localStorage.getItem("ip");

// Define default headers
export const DEFAULT_HEADERS = {
  IP: IP,
};

axios.interceptors.response.use(
  function (config) {
    if (
      config.data?.reason?.includes?.("token") &&
      config.data?.reason?.includes?.("expired") &&
      !window.location.href.includes?.("/signin")
    ) {
      // getIP()
      localStorage.removeItem("jwtUserToken");
      localStorage.removeItem("companies");
      localStorage.removeItem("token exp");
      window.location.href = "/signin?token-expired";
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.request.use(
  (config) => {
    // use config.params if it has been set
    config.params = config.params || {};
    // add any client instance specific params to config
    config.params["dl"] = localStorage.langCity ?? "en";

    const token = localStorage.jwtUserToken;

    if (token) {
      axios.defaults.headers["token"] = token;
    }

    // Add frontend version to all requests
    config.headers = config.headers || {};
    config.headers["X-Frontend-Version"] = getVersionHeader();
    config.headers["X-App-Version"] = getVersionHeader();

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    Notiflix.Notify.failure("Something went Wrong - " + error?.message);
    return Promise.reject(error);
  }
);

axios.defaults.baseURL = BASE_URL;

axios.defaults.headers = {
  ...axios.defaults.headers,
  ...DEFAULT_HEADERS,
};

window.axios = axios;

export default axios;
